exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sub-header-title {\n  margin-top: 0;\n  margin-bottom: 12px;\n}\n\n.sub-nav-bg-color {\n  background-color: #fafafa;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/replication/replication-management/replication-management.component.css
// module id = 824
// module chunks = 0